var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.wrpCls},[_c('avatar-dropdown',{class:_vm.prefixCls,attrs:{"menu":_vm.showMenu,"current-user":_vm.currentUser}}),(_vm.isSelectLang)?_c('select-lang',{class:_vm.prefixCls}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }